'use strict';

import React from 'react';
// import classNames from 'classnames';
import Table from 'components/clarity-ui/components/table/table';
import TableHeader from 'components/clarity-ui/components/table/tableHeader';
import TableRow from 'components/clarity-ui/components/table/tableRow';
import TableData from 'components/clarity-ui/components/table/tableData';

class TextResultsTableComponent extends React.Component {

  // getAdditionalRowClassName (isSelected) {
  //   return classNames({
  //     'Selectable': true,
  //     'Selected': isSelected
  //   });
  // }

  renderTableRows (textDetectorResults) {
    const tableRows = textDetectorResults.map((item) => {
      const { pageId, webPage } = item;
      const { domain, title } = webPage;
      // const isSelected = selectedClfTargetId === clfTargetId;
      return (
        <TableRow key={pageId}>
          <TableData>{pageId}</TableData>
          <TableData>{domain}</TableData>
          <TableData>{title}</TableData>
        </TableRow>
      );
    });

    return tableRows;
  }

  render () {
    const { textDetectorResults } = this.props;
    return (
      <Table scrollable>
        <tbody>
          <TableRow isHeader>
            <TableHeader>Page Id</TableHeader>
            <TableHeader>Domain</TableHeader>
            <TableHeader>Title</TableHeader>
          </TableRow>
          { this.renderTableRows(textDetectorResults) }
        </tbody>
      </Table>
    );
  }
}

export default TextResultsTableComponent;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/targetResults/textResults/textResultsTable.component.jsx